<template>
  <Header v-on:setOverlay="setOverlay" />
  <transition name="fade" @after-leave="afterLeave" @before-enter="beforeEnter">
    <router-view :key="$route.fullPath" v-on:setOverlay="setOverlay" />
  </transition>
  <Footer />
  <ReturnToTopButton />
</template>
<script>
import "@/assets/styles/index.scss";
// import { useRoute } from "vue-router";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import ReturnToTopButton from "@/components/common/ReturnToTopButton";
import { ref } from "@vue/reactivity";
import { provide } from "vue";
// import { onMounted } from 'vue';

export default {
  components: {
    Header,
    Footer,
    ReturnToTopButton
  },
  setup() {
    const setOverlay = isOverlay => {
      const scrollWidth = window.innerWidth - document.body.clientWidth;

      document.body.scrollHeight - window.innerHeight > 0 && isOverlay
        ? document.body.setAttribute(
            "style",
            `${document.body.getAttribute("style") ||
              ""} margin-right:${scrollWidth}px;`
          )
        : document.body.setAttribute(
            "style",
            `${document.body.getAttribute("style") &&
              document.body
                .getAttribute("style")
                .replace(` margin-right:${scrollWidth}px;`, "")}`
          );

      isOverlay &&
        document.body.setAttribute(
          "class",
          `${document.body.getAttribute("class") || ""} overlay`
        );
      !isOverlay &&
        document.body.setAttribute(
          "class",
          `${document.body.getAttribute("class") &&
            document.body.getAttribute("class").replace(" overlay", "")}`
        );
    };

    const transitionEnd = ref(false);

    const afterLeave = () => {
      transitionEnd.value = true;
      //console.log("after ", transitionEnd);
    };
    const beforeEnter = () => {
      transitionEnd.value = false;
      //console.log("before ", transitionEnd);
    };
    provide("transitionEnd", transitionEnd);
    return {
      setOverlay,
      afterLeave,
      transitionEnd,
      beforeEnter
    };
  }
};
</script>
<style lang="scss" scope>
@use "@/assets/styles/settings/_variables.scss";
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.1s;
}
.fade-enter-active {
  transition-delay: 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

main {
  min-height: calc(100vh - (417px + 67px));
}
/*
@media (min-width: 992px) {
  main {
    min-height: calc(100vh - (302px + 67px));
  }
}*/
@media (min-width: 1200px) {
  main {
    min-height: calc(100vh - (388px + 67px));
  }
}
/*
::-webkit-scrollbar {
  width: variables.$scrollbar-width;
}
::-webkit-scrollbar-track {
  background: variables.$track-color;
}
::-webkit-scrollbar-thumb {
  background: variables.$scroll-thumb;
}
::-webkit-scrollbar-thumb:hover {
  background: variables.$scroll-thumb-hover;
}
*/
</style>
